import { TipsMapType } from '@op/components/BubbleCommon';
import { CONTACT_NAME } from '@op/constants';
import React from 'react';

export const gameCategoryTipsMap: TipsMapType = {
  en: (
    <>
      Only top-tier games included. Contact {CONTACT_NAME} if you need to expand.
    </>
  ),
  zh: (
    <>
      当前仅包含该品类头部游戏，如需拓展联系 {CONTACT_NAME}
    </>
  ),
};
